export function changeHtmlBackground(color) {
    document.documentElement.style.background = color;
}
export function changeHtmlBackgroundOnColorChange(vue) {
    return vue.$store.watch((state) => {
        return state.layout.color;
    }, (color) => changeHtmlBackground(color.background));
}
